import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonuses" className="bg-surface px-5 py-20 sm:py-24" data-id="element-1" data-mp="gxge3tl8ejfm">
      <div className="mx-auto max-w-6xl" data-id="element-2" data-mp="vtnzuycafsx0">
        <div className="text-center" data-id="element-3" data-mp="qtt52jpe6j6o">
          <GiftIcon className="mx-auto h-10 w-10 text-sun" aria-hidden="true" data-id="element-4" data-mp="qsrt8d0jxsnw" />
          <h2 id="bonuses" className="mt-4 text-3xl font-black uppercase leading-tight text-white sm:text-5xl" data-id="element-5" data-mp="14t2kvi9orba4">
            5 bonos estratégicos
            <span className="block text-sun" data-id="element-6" data-mp="zu7t3qtqqcdv">Siempre incluidos</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-cream/90" data-id="element-7" data-mp="1ei2o5dv80su4">
            Actividades organizadas y listas para cada situación.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-3xl border border-line bg-ink" data-id="element-8" data-mp="1njkc1ievdytd">
          <div className="hidden grid-cols-[60px_1.1fr_1.4fr_150px] gap-6 border-b border-line px-6 py-4 text-xs font-black uppercase tracking-widest text-muted md:grid" data-id="element-9" data-mp="1jigtgo5ftoog">
            <span data-id="element-10" data-mp="3pseqkgs05sfv">#</span>
            <span data-id="element-11" data-mp="3trx7l1gpdjdf">Bono</span>
            <span data-id="element-12" data-mp="3tr5h251yqbu0">¿Qué resuelve?</span>
            <span className="text-right" data-id="element-13" data-mp="3ts6z4thebyl8">Valor</span>
          </div>
          <ul data-id="element-14" data-mp="2kkq0lbwr3wz">
            {bonuses.map(b => <li key={b.n} className="grid grid-cols-[48px_1fr] gap-x-4 gap-y-2 border-b border-line px-6 py-5 last:border-b-0 md:grid-cols-[60px_1.1fr_1.4fr_150px] md:items-center md:gap-6" data-id="element-15" data-mp="7kpaemfxsish">
                <span className="row-span-3 text-2xl font-black text-sun md:row-span-1" data-id="element-16" data-mp="chz6gkxtzspa">{b.n}</span>
                <h3 className="text-lg font-black text-white" data-id="element-17" data-mp="gj0yagpf52h8">{b.title}</h3>
                <p className="text-base text-muted" data-id="element-18" data-mp="lcvpe57csjqc">{b.solves}</p>
                <span className="flex items-center gap-2 md:justify-self-end" data-id="element-19" data-mp="qa5c3d3cyhah">
                  <s className="text-sm font-bold text-muted" aria-label="Valor USD 7" data-id="element-20" data-mp="vate0tt4kijh">USD 7</s>
                  <span className="inline-flex items-center gap-1 rounded-full bg-brand px-3 py-1 text-xs font-black uppercase tracking-wider text-ink" data-id="element-21" data-mp="1094kcuk7oawy">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-22" data-mp="alifqttb2inp" />
                    Gratis
                  </span>
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl border-2 border-dashed border-sun/50 px-6 py-8 text-center" data-id="element-23" data-mp="kd4x77w8ldyw">
          <p className="text-xl font-black uppercase text-sun sm:text-2xl" data-id="element-24" data-mp="tbqc8t2i2aux">Los 5 bonos → incluidos con tu MegaPack</p>
          <p className="mt-3 text-base text-cream/90" data-id="element-25" data-mp="od5dky2wbz8l">Los recibes junto a los seis tomos, sin costo extra.</p>
        </div>
      </div>
    </section>;
}